@if (mostrandoTelaCriacao) {
    <app-especialidade [pessoa]="pessoa()" [modoCriacao]="true" (salvarCriacao)="onSalvarCriacao($event)" (cancelarCriacao)="onDialogCriarFechar()"></app-especialidade>
} @else if (!selectedDetail()) {
    <app-especialidade-lista [pessoa]="pessoa()" (rowClick)="onEspecialidadeRowClick($event)" (criar)="onEspecialidadeCriar()" (removerRow)="onEspecialidadeRemover($event)"></app-especialidade-lista>
} @else {
    <app-especialidade [pessoa]="pessoa()" [selectedDetail]="$any(selectedDetail())" (voltar)="onEspecialidadeVoltar()" (salvarEdicao)="onSalvarEdicao($event)" (remover)="onEspecialidadeRemover($event)"></app-especialidade>
}
